/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportUserBodyItem
 */
export interface ImportUserBodyItem {
    /**
     * 
     * @type {string}
     * @memberof ImportUserBodyItem
     */
    devour_user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserBodyItem
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserBodyItem
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserBodyItem
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportUserBodyItem
     */
    last_name?: string;
}

/**
 * Check if a given object implements the ImportUserBodyItem interface.
 */
export function instanceOfImportUserBodyItem(value: object): value is ImportUserBodyItem {
    return true;
}

export function ImportUserBodyItemFromJSON(json: any): ImportUserBodyItem {
    return ImportUserBodyItemFromJSONTyped(json, false);
}

export function ImportUserBodyItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportUserBodyItem {
    if (json == null) {
        return json;
    }
    return {
        
        'devour_user_id': json['devour_user_id'] == null ? undefined : json['devour_user_id'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone_number': json['phone_number'] == null ? undefined : json['phone_number'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
    };
}

export function ImportUserBodyItemToJSON(json: any): ImportUserBodyItem {
    return ImportUserBodyItemToJSONTyped(json, false);
}

export function ImportUserBodyItemToJSONTyped(value?: ImportUserBodyItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'devour_user_id': value['devour_user_id'],
        'email': value['email'],
        'phone_number': value['phone_number'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
    };
}

